































import { Component, Prop, Vue } from "vue-property-decorator";
import TopProductBadge from "./TopProductBadge.vue";
import Rating from "./Rating.vue";
import ButtonProfi from "./ButtonProfi.vue";

@Component({
  components: {
    TopProductBadge,
    Rating,
    ButtonProfi
  }
})
export default class ProductItem extends Vue {
  @Prop() private product!: object;
  @Prop() private isTop!: boolean;

  private goToProduct(url: string) {
    window.location.href = url;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.font.fontName,
      "--backgroundSize": this.$store.state.globalConfig.productImageMode,
      "--app-container-background-color": this.$store.state.globalCss.colors
        .modal.backgroundColor
    };
  }

  get getCurrencyFormat(): string {
    return this.$store.state.globalConfig.currencyFormat;
  }

  get getCurrency(): string {
    return this.$store.state.globalConfig.currency;
  }
}
